import React, { useState, useEffect } from "react"
import sanityClient from "../client.js"

export default function Intro({ lang, setLang }) {
  const [introducopt, setIntroducopt] = useState(null)

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "intro"]{content, lang}`)
      .then((data) => setIntroducopt(data))
      .catch(console.error)
  }, [])

  const introduc = introducopt ? introducopt.filter(intro => intro.lang.includes(lang)) : null

  return (
    <div id='intro' className="pad">
      <div id='name'>
        <img src="wordmark.svg" className="word" alt="Mocoso" />
      </div>

      <button onClick={() => setLang('ESP')} className={lang === 'ESP' ? "selected" : "unselected"}>
        ESP
      </button>
      <button onClick={() => setLang('ENG')} className={lang === 'ENG' ? "selected" : "unselected"}>
        ENG
      </button>

      <p id='description'>
        {introduc && introduc[0] && introduc[0].content}
      </p>
    </div>
  )
}
